(() => {
  if (window.cooldoLandingReady) return;
  window.cooldoLandingReady = true;
  const visibleBuyControls = new Set();
  const buyObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) visibleBuyControls.add(entry.target);
      else visibleBuyControls.delete(entry.target);
    }
    document.documentElement.classList.toggle('cl-buy-controls-visible', visibleBuyControls.size > 0);
  });
  document.querySelectorAll('.cl-product form').forEach(form => buyObserver.observe(form));
  document.querySelectorAll('[data-landing-reviews]').forEach(root => {
    const source = root.querySelector('[data-landing-review-source]');
    const gallery = root.querySelector('[data-landing-review-gallery]');
    if (!source || !gallery) return;
    const track = gallery.querySelector('[data-landing-review-track]');
    const normalize = value => value.replace(/\s+/g, ' ').trim().toLocaleLowerCase();
    const excluded = new Set(gallery.dataset.excludedBodies.split('\n').map(normalize));
    const build = () => {
      const items = [...source.querySelectorAll('.jdgm-carousel-item')].filter(item => {
        const body = normalize(item.querySelector('.jdgm-carousel-item__review-body')?.textContent || '');
        return body && !excluded.has(body);
      });
      if (!items.length) return;
      for (const item of items) {
        const card = document.createElement('article');
        card.className = 'cl-review-card';
        for (const selector of ['.jdgm-carousel-item__review-rating', '.jdgm-carousel-item__review-title', '.jdgm-carousel-item__review-body', '.jdgm-carousel-item__reviewer-name']) {
          const original = item.querySelector(selector);
          if (!original) continue;
          const copy = original.cloneNode(true);
          copy.removeAttribute('style');
          copy.classList.remove('jdgm-line-clamp', 'jdgm-ellipsis');
          card.append(copy);
        }
        track.append(card);
      }
      source.hidden = true;
      gallery.hidden = false;
      observer.disconnect();
    };
    const observer = new MutationObserver(build);
    observer.observe(source, {childList:true, subtree:true});
    build();
    gallery.querySelectorAll('[data-review-step]').forEach(button => button.addEventListener('click', () => {
      track.scrollBy({left: Number(button.dataset.reviewStep) * (track.firstElementChild.getBoundingClientRect().width + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
  });
  function update(root) {
    const select = root.querySelector('[data-landing-variant]');
    const option = select?.selectedOptions[0];
    if (!option) return;
    root.querySelector('[data-landing-price]').textContent = option.dataset.price;
    const compare = root.querySelector('[data-landing-compare]');
    compare.textContent = option.dataset.compare;
    compare.hidden = option.dataset.onSale !== 'true';
    const button = root.querySelector('[type="submit"]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? root.dataset.soldOutLabel : root.dataset.addLabel;
    const details = root.querySelector('[data-landing-details]');
    if (details) {
      const url = new URL(details.href);
      url.searchParams.set('variant', select.value);
      details.href = url.href;
    }
    const error = root.querySelector('[data-landing-error]');
    error.hidden = true;
    error.textContent = '';
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-landing-variant]')) update(event.target.closest('[data-landing-product]'));
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link) return;
    if (link.matches('[data-landing-pack-cta]')) {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
      const root = document.getElementById(url.hash.slice(1));
      if (root?.matches('[data-landing-product]')) {
        const select = root.querySelector('[data-landing-variant]');
        select.value = root.dataset.defaultVariant;
        update(root);
      }
    }
    if (link.closest('[data-landing-reviews]') && !link.matches('[data-landing-pack-cta]')) {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const reviews = document.getElementById('opiniones');
      reviews.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      reviews.focus({preventScroll:true});
    }
  }, true);
  document.addEventListener('cart:error', event => {
    const error = event.target.closest('[data-landing-product]')?.querySelector('[data-landing-error]');
    if (error) { error.textContent = event.detail.message; error.hidden = false; }
  });
})();
